/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Main Index template to autogenerate all the libs
 * Used by "prepareTemplates"
 */

// import all the available components and extensions
import Blockquote from './elements/Blockquote'
import Code from './elements/Code'
import Dd from './elements/Dd'
import Div from './elements/Div'
import Dl from './elements/Dl'
import Dt from './elements/Dt'
import H from './elements/H'
import H1 from './elements/H1'
import H2 from './elements/H2'
import H3 from './elements/H3'
import H4 from './elements/H4'
import H5 from './elements/H5'
import H6 from './elements/H6'
import Hr from './elements/Hr'
import Img from './elements/Img'
import Ingress from './elements/Ingress'
import Lead from './elements/Lead'
import Li from './elements/Li'
import Link from './elements/Link'
import Ol from './elements/Ol'
import P from './elements/P'
import Paragraph from './elements/Paragraph'
import Span from './elements/Span'
import Td from './elements/Td'
import Th from './elements/Th'
import Tr from './elements/Tr'
import Typography from './elements/Typography'
import Ul from './elements/Ul'
import Accordion from './components/accordion/Accordion'
import Anchor from './components/anchor/Anchor'
import AriaLive from './components/aria-live/AriaLive'
import Autocomplete from './components/autocomplete/Autocomplete'
import Avatar from './components/avatar/Avatar'
import Badge from './components/badge/Badge'
import Breadcrumb from './components/breadcrumb/Breadcrumb'
import Button from './components/button/Button'
import Card from './components/card/Card'
import Checkbox from './components/checkbox/Checkbox'
import CopyOnClick from './components/copy-on-click/CopyOnClick'
import CountryFlag from './components/country-flag/CountryFlag'
import DateFormat from './components/date-format/DateFormat'
import DatePicker from './components/date-picker/DatePicker'
import Dialog from './components/dialog/Dialog'
import Drawer from './components/drawer/Drawer'
import Dropdown from './components/dropdown/Dropdown'
import Filter from './components/filter/Filter'
import Flex from './components/flex/Flex'
import FormLabel from './components/form-label/FormLabel'
import FormStatus from './components/form-status/FormStatus'
import GlobalError from './components/global-error/GlobalError'
import GlobalStatus from './components/global-status/GlobalStatus'
import Grid from './components/grid/Grid'
import Heading from './components/heading/Heading'
import HeightAnimation from './components/height-animation/HeightAnimation'
import HelpButton from './components/help-button/HelpButton'
import Icon from './components/icon/Icon'
import IconPrimary from './components/icon-primary/IconPrimary'
import InfoCard from './components/info-card/InfoCard'
import Input from './components/input/Input'
import InputMasked from './components/input-masked/InputMasked'
import List from './components/list/List'
import ListFormat from './components/list-format/ListFormat'
import Logo from './components/logo/Logo'
import Menu from './components/menu/Menu'
import Modal from './components/modal/Modal'
import NumberFormat from './components/number-format/NumberFormat'
import Pagination from './components/pagination/Pagination'
import Popover from './components/popover/Popover'
import PortalRoot from './components/portal-root/PortalRoot'
import ProgressIndicator from './components/progress-indicator/ProgressIndicator'
import Radio from './components/radio/Radio'
import Section from './components/section/Section'
import Skeleton from './components/skeleton/Skeleton'
import SkipContent from './components/skip-content/SkipContent'
import Slider from './components/slider/Slider'
import Space from './components/space/Space'
import Stat from './components/stat/Stat'
import StepIndicator from './components/step-indicator/StepIndicator'
import Switch from './components/switch/Switch'
import Table from './components/table/Table'
import Tabs from './components/tabs/Tabs'
import Tag from './components/tag/Tag'
import TermDefinition from './components/term-definition/TermDefinition'
import Textarea from './components/textarea/Textarea'
import Timeline from './components/timeline/Timeline'
import ToggleButton from './components/toggle-button/ToggleButton'
import Tooltip from './components/tooltip/Tooltip'
import Upload from './components/upload/Upload'
import VisuallyHidden from './components/visually-hidden/VisuallyHidden'

// define / export all the available components
export {
  Blockquote,
  Code,
  Dd,
  Div,
  Dl,
  Dt,
  H,
  H1,
  H2,
  H3,
  H4,
  H5,
  H6,
  Hr,
  Img,
  Ingress,
  Lead,
  Li,
  Link,
  Ol,
  P,
  Paragraph,
  Span,
  Td,
  Th,
  Tr,
  Typography,
  Ul,
  Accordion,
  Anchor,
  AriaLive,
  Autocomplete,
  Avatar,
  Badge,
  Breadcrumb,
  Button,
  Card,
  Checkbox,
  CopyOnClick,
  CountryFlag,
  DateFormat,
  DatePicker,
  Dialog,
  Drawer,
  Dropdown,
  Filter,
  Flex,
  FormLabel,
  FormStatus,
  GlobalError,
  GlobalStatus,
  Grid,
  Heading,
  HeightAnimation,
  HelpButton,
  Icon,
  IconPrimary,
  InfoCard,
  Input,
  InputMasked,
  List,
  ListFormat,
  Logo,
  Menu,
  Modal,
  NumberFormat,
  Pagination,
  Popover,
  PortalRoot,
  ProgressIndicator,
  Radio,
  Section,
  Skeleton,
  SkipContent,
  Slider,
  Space,
  Stat,
  StepIndicator,
  Switch,
  Table,
  Tabs,
  Tag,
  TermDefinition,
  Textarea,
  Timeline,
  ToggleButton,
  Tooltip,
  Upload,
  VisuallyHidden,
}

export default {}
